module.exports = __webpack_public_path__ + "static/media/logo.1769587d.png";